import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertSuccessModalComponent } from './success/alert-success.component';
// Sweet Alert
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private modalService: NgbModal) {}

  toastSuccess(message: string) {
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 3000,
    });
  }

  toastFailure(message: string) {
    Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: message,
      showConfirmButton: false,
      timer: 3000,
    });
  }

  alertSuccess(title: string, subTitle: string): Promise<any> {
    const modalRef = this.modalService.open(AlertSuccessModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.subTitle = subTitle;

    return new Promise((resolve) => {
      modalRef.dismissed.subscribe((result) => {
        resolve(result);
      });
    });
  }

  alertQuestion(title: string, subTitle: string, showCancel: boolean = true) {
    return Swal.fire({
      title: title,
      text: subTitle,
      icon: 'question', //No acepta el parametro
      showCancelButton: showCancel, // Controla si se muestra el botón Cancel
      confirmButtonColor: '#364574',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: 'OK',
      reverseButtons: true, // Cambia la posición de los botones
    });
  }

  alertConfirm(title: string, subTitle: string, showCancel: boolean = true) {
    return Swal.fire({
      title: title,
      text: subTitle,
      icon: 'success', //No acepta el parametro
      showCancelButton: showCancel, // Controla si se muestra el botón Cancel
      confirmButtonColor: '#364574',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: 'OK',
      reverseButtons: true, // Cambia la posición de los botones
    });
  }

  alertWarning(title: string, subTitle: string, showCancel: boolean = true) {
    return Swal.fire({
      title: title, //'Oops...',
      text: subTitle, //'Something went wrong!',
      icon: 'warning',
      showCancelButton: showCancel, // Controla si se muestra el botón Cancel
      confirmButtonColor: '#364574',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: 'OK',
      reverseButtons: true, // Cambia la posición de los botones
    });
  }

  alertInfo(title: string, subTitle: string, showCancel: boolean = true) {
    return Swal.fire({
      title: title,
      text: subTitle,
      icon: 'info',
      showCancelButton: showCancel, // Controla si se muestra el botón Cancel
      confirmButtonColor: '#364574',
      cancelButtonColor: 'hsl(0, 0.00%, 100.00%)',
      confirmButtonText: 'OK',
      reverseButtons: true, // Cambia la posición de los botones
    });
  }
}
